module.exports = __webpack_public_path__ + "img/_ABS9793(1).086bab01.jpg";